module.exports = __webpack_public_path__ + "static/img/4.f786e73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/sp/4.png
// module id = QXHp
// module chunks = 0